import debounce from 'lodash/debounce';
import { useLayoutEffect, useState } from 'react';

type WindowSize = {
  height: number;
  width: number;
};

export const useWindowSize = (debounceDelay = 250) => {
  const [windowSize, setWindowSize] = useState<WindowSize>({ height: 0, width: 0 });

  useLayoutEffect(() => {
    const updateWindowWidth = debounce(() => {
      setWindowSize({ height: window.innerHeight, width: window.innerWidth });
    }, debounceDelay);
    updateWindowWidth();

    window.addEventListener('resize', updateWindowWidth);

    return () => {
      window.removeEventListener('resize', updateWindowWidth);
      updateWindowWidth.cancel();
    };
  }, [debounceDelay]);

  return windowSize;
};
